export default "__VITE_ASSET__SoP$UsFh__"